 <template>
  <v-dialog v-model="dialog" :max-width="520" persistent>
    <v-card class="pt-2 pl-0 pr-0">
      <v-card-title
        class="headline-6"
        :class="{ 'subtitle-2': $vuetify.breakpoint.xs }"
        style="word-break: normal; !important"
      >
        {{
          (action == "associate"
            ? $vuetify.lang.t("$vuetify.ASSOCIAR_CIRCUITOS")
            : $vuetify.lang.t("$vuetify.DISSOCIAR_CIRCUITOS")) +
          ": " +
          (entity ? entity.nome : "")
        }}
      </v-card-title>

      <v-divider></v-divider>

      <v-form
        ref="form"
        lazy-validation
        class="overflow-y-auto overflow-x-hidden"
        :class="{ 'overflow-y-hidden': true }"
      >
        <v-list
          class="ma-0 pa-0"
          :max-height="$vuetify.breakpoint.xl ? 480 : 480"
          min-height="480"
        >
          <div class="ma-0 pa-0">
            <v-col cols="12" class="ma-0 justify-center mb-n3 pt-4">
              <v-row>
                <v-col cols="5" class="ml-8 mt-n4 pr-0 mr-0">
                  <v-row>
                    <span
                      class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
                    >
                      {{ $vuetify.lang.t("$vuetify.BUSCAR") }}:</span
                    >
                  </v-row>
                  <v-row class="mr-1">
                    <v-text-field
                      v-model.trim="searchText"
                      dense
                      label="Regular"
                      :placeholder="$vuetify.lang.t('$vuetify.DESIGNACAO_TPZ')"
                      single-line
                      solo
                      append-icon="mdi-magnify"
                      @click:append="
                        searchEntities(searchText);
                        selectedCheckList = [];
                        active = false;
                      "
                      @keypress.enter.stop.prevent="
                        searchEntities(searchText);
                        selectedCheckList = [];
                        active = false;
                      "
                      :rules="[
                        (v) =>
                          (v && v.length >= 3) ||
                          $vuetify.lang.t('$vuetify.MIN_CARACTERES', 3),
                      ]"
                    ></v-text-field>
                  </v-row>
                </v-col>
              </v-row>

              <v-row class="mt-n4">
                <v-col class="ml-1" :style="{ height: 24 + 'em' }">
                  <v-checkbox
                    :input-value="active"
                    v-model="active"
                    color="blue darken-2"
                    dense
                    :value="active"
                    @click.native="selectDeselectAll(active)"
                    class="ml-7"
                    :label="$vuetify.lang.t('$vuetify.SELECIONAR_TODOS')"
                    v-show="itemList.length > 0"
                  ></v-checkbox>

                  <v-lazy
                    :options="{ threshold: 0.6 }"
                    transition="slide-x-transition"
                  >
                    <v-list
                      v-show="itemList.length > 0"
                      two-line
                      flat
                      class="ml-0 pt-3 overflow-y-auto"
                    >
                      <v-list-item-group multiple>
                        <v-virtual-scroll
                          bench="0"
                          :items="itemList"
                          item-height="44"
                          class="ml-3 mt-0 overflow-y-auto"
                          :height="$vuetify.breakpoint.xs ? 170 : 280"
                        >
                          <template v-slot:default="{ item }">
                            <v-list-item
                              class="mt-n0"
                              :class="{ 'ml-n3': $vuetify.breakpoint.xs }"
                            >
                              <template v-slot:default="{ active }">
                                <v-list-item-action>
                                  <v-checkbox
                                    v-model="selectedCheckList"
                                    color="blue darken-2"
                                    dense
                                    :value="item"
                                    @click.native="
                                      selectItem(item, true, active)
                                    "
                                  ></v-checkbox>
                                </v-list-item-action>

                                <v-list-item-content
                                  class="ml-n3"
                                  :class="{ 'ml-n7': $vuetify.breakpoint.xs }"
                                >
                                  <v-list-item-title
                                    class="subtitle-2"
                                    :class="{ caption: $vuetify.breakpoint.xs }"
                                  >
                                    {{ item.designacaoTpz }}</v-list-item-title
                                  >
                                </v-list-item-content>
                              </template>
                            </v-list-item>
                          </template>
                        </v-virtual-scroll>
                      </v-list-item-group>
                    </v-list>
                  </v-lazy>

                  <v-lazy
                    :options="{ threshold: 0.6 }"
                    transition="slide-x-transition"
                  >
                    <WarningPanel
                      class="mt-12 pt-12"
                      :mobile="true"
                      :message="$vuetify.lang.t('$vuetify.NENHUM_CIRCUITO')"
                      v-show="itemList.length == 0 && !loading"
                      :small="true"
                    ></WarningPanel>
                  </v-lazy>

                  <v-row
                    class="d-flex align-center justify-center"
                    style="height: 60%"
                  >
                    <v-progress-circular
                      v-if="loading"
                      :size="30"
                      :width="4"
                      color="blue darken-2"
                      indeterminate
                      class="ml-n2 mt-6 mb-n1 text-center"
                    ></v-progress-circular>
                  </v-row>
                </v-col>

                <v-divider
                  vertical
                  class="mt-6 mb-8"
                  :style="{ height: 24 + 'em' }"
                >
                </v-divider>

                <v-col
                  class="overflow-y-auto overflow-x-hidden mt-8 mr-6"
                  :style="{ height: 24 + 'em' }"
                >
                  <v-col
                    cols="11"
                    class="ml-4 mt-n8"
                    :class="{ 'mt-n8': $vuetify.breakpoint.xs }"
                  >
                    <WarningPanel
                      class="mt-9 pt-12 ml-n0"
                      :mobile="true"
                      :message="
                        $vuetify.lang.t('$vuetify.NENHUM_CIRCUITO_SELECIONADO')
                      "
                      v-show="selectedItemList.length == 0"
                      :small="true"
                    >
                    </WarningPanel>

                    <v-row
                      class="ml-2 mt-4 d-flex justify-left"
                      :class="{ 'ml-n7': $vuetify.breakpoint.xs }"
                      v-for="item in selectedItemList"
                      :key="item.id"
                      justify="center"
                    >
                      <v-lazy
                        :options="{ threshold: 0.6 }"
                        transition="slide-x-transition"
                      >
                        <v-chip
                          :key="item.id + 1"
                          color="blue darken-2"
                          class="ml-0 mr-2 mt-2"
                          :class="{ 'ml-2': $vuetify.breakpoint.xs }"
                          label
                          :small="$vuetify.breakpoint.xs"
                          @click:close="selectItem(item, false)"
                          close
                          :id="item.nome"
                        >
                          {{ item.designacaoTpz }}
                        </v-chip>
                      </v-lazy>
                    </v-row>
                  </v-col>
                </v-col>
              </v-row>
            </v-col>
          </div>
        </v-list>
      </v-form>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-2"
          text
          @click="
            $refs.form.resetValidation();
            $refs.form.reset();
            close();
            cleanFields();
          "
        >
          {{ $vuetify.lang.t("$vuetify.CANCELAR") }}
        </v-btn>

        <v-btn
          color="blue darken-2"
          text
          @click="
            $refs.form.validate();
            entity.circuitos = selectedItemList;
            send(entity);
            cleanFields();
          "
          :loading="isLoading"
        >
          {{ $vuetify.lang.t("$vuetify.ENVIAR") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import WarningPanel from "../../components/panels/WarningPanel";

export default {
  components: {
    WarningPanel,
  },
  props: {
    close: Function,
    dialog: Boolean,
    send: Function,
    entity: Object,
    isLoading: Boolean,
    action: String,
  },
  methods: {
    searchEntities(searchText) {
      if (searchText.length < 3) {
        return;
      }

      this.loading = true;
      this.itemList = [];

      this.$get("/circuito/all", {
        searchText: searchText,
      }).then((response) => {
        this.itemList = response.data;
        this.loading = false;
      });
    },
    cleanFields() {
      this.itemList = [];
      this.selectedItemList = [];
      this.searchText = "";
      this.selectedCheckList = [];
    },
    selectDeselectAll(active) {
      this.selectedCheckList = [];
      var vm = this;

      if (active) {
        this.itemList.forEach(function (item, i) {
          vm.selectedCheckList.push(vm.itemList[i]);

          var sItem = vm.selectedItemList.filter((obj) => obj.id == item.id);
          if (!sItem || sItem.length == 0) {
            vm.selectedItemList.push(vm.itemList[i]);
          }
        });
      } else {
        this.itemList.forEach(function (item) {
          vm.selectedItemList = vm.selectedItemList.filter(
            (obj) => obj.id != item.id
          );
        });
      }
    },
    selectItem(item, checkList) {
      if (
        !this.containsItem(item, this.selectedItemList) &&
        this.containsItem(item, this.selectedCheckList)
      ) {
        this.selectedItemList.push(item);
      } else {
        if (!checkList || !this.containsItem(item, this.selectedCheckList))
          this.selectedItemList = this.selectedItemList.filter(function (
            value
          ) {
            return value.id != item.id;
          });

        if (!checkList)
          this.selectedCheckList = this.selectedCheckList.filter(function (
            value
          ) {
            return value.id != item.id;
          });
      }
    },
    containsItem(item, list) {
      for (var index in list) {
        if (list[index].id == item.id) {
          return true;
        }
      }

      return false;
    },
  },
  data() {
    return {
      loading: false,
      itemList: [],
      check: false,
      searchText: "",
      selectedItemList: [],
      selectedCheckList: [],
      selectedItem: undefined,
    };
  },
  created: function () {
    this.$root.$on("invalidateFields", () => {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.selectedItemList = [];
      this.selectedCheckList = [];
    });
  },
};
</script>